import axios from 'axios'

var API_URL = process.env.VUE_APP_URL + '/api/usuarios/'
class UsuarioService {
    signup(usuario) {
        return axios.post(API_URL, usuario)
    }

    modifUser(usuario) {
        return axios.put(API_URL, usuario)
    }
    modifZona(id, zona) {
        return axios.put(API_URL + 'zona?id=' + id + '&zona=' + zona)
    }

    modifUserBodell(usuario) {
        return axios.put(API_URL + 'bodell', usuario)
    }

    updatePerfil(usuario) {
        return axios.put(API_URL + 'update-perfil', usuario)
    }

    getUserId(id) {
        return axios.get(API_URL + id)
    }

    getAllUsers(num) {
        return axios.get(API_URL + 'all' + (num ? '?index=' + num : ''))
    }

    getUsersFiltro(num, n, t, h, a) {
        return axios.get(API_URL + 'filtro' + (num ? '?index=' + num : '') + (n ? '&n=' + n : '') + (t ? '&t=' + t : '') + (h ? '&h=' + h : '') + (a ? '&a=' + a : ''))
    }

    getUserCheckAdminId(id) {
        return axios.get(API_URL + 'admin/' + id)
    }

    getVendedores() {
        return axios.get(API_URL + 'vendedores')
    }

    getClientes(id) {
        return axios.get(API_URL + 'clientes?id=' + id)
    }

    getAllClientes() {
        return axios.get(API_URL + 'clientes/all')
    }

    
    getClientesNoHabilitados() {
        return axios.get(API_URL + 'clientes/no-habilitados')
    }

    getClientesCarritos(id) {
        return axios.get(API_URL + 'clientes/carrito?id=' + id)
    }

    getAllClientesCarritos() {
        return axios.get(API_URL + 'clientes/carrito/all')
    }


    buscarCliente(codigo) {
        return axios.get(API_URL + 'cliente?cod=' + codigo)
    }
    buscarClienteId(id) {
        return axios.get(API_URL + 'cliente/id?id=' + id)
    }
    buscarClienteIdZon(id) {
        return axios.get(API_URL + 'cliente/zona?id=' + id)
    }
    buscarClienteTipo(id) {
        return axios.get(API_URL + 'cliente/tipoCliente?id=' + id)
    }
    buscadorCliente(nombre) {
        return axios.get(API_URL + 'buscador/cliente?nom=' + nombre)
    }

    buscadorClienteCuit(cuit) {
        return axios.get(API_URL + 'cuit?cuit=' + cuit)
    }

    getClienteErpCuit(cuit) {
        return axios.get(API_URL + 'erp-cuit?cuit=' + cuit)
    }

    buscadorClienteBodellCuit(cuit) {
        return axios.get(API_URL + 'bodell/' + cuit)
    }

    getIvasBodell() {
        return axios.get(API_URL + 'bodell/ivas')
    }

    buscadorDireccionesClienteIdcli(idcli) {
        return axios.get(API_URL + 'cuit/direcciones?idcli=' + idcli)
    }

    direccionesUsu(id) {
        return axios.get(API_URL + 'direcciones/' + id)
    }
    direccionesUsuBodell(id) {
        return axios.get(API_URL + 'direcciones-bodell/' + id)
    }
    idcvd(id) {
        return axios.get(API_URL + 'cdv-bodell/' + id)
    }
    guardarDireccionesUsu(direcciones) {
        return axios.post(API_URL + 'direcciones', direcciones)
    }
}

export default new UsuarioService()